










import {Component} from "vue-property-decorator";
import Loading from "@/components/Loading.vue";
import VueError from "@/components/VueError.vue";
import Spinner from "@/components/Spinner.vue";


import {BssService, curBssService} from "@/services/BssService";
import {UniqueDevicesTimeSeriesPoint} from "@/services/CoreClient";
import KeyValue from "@/components/KeyValue.vue";
import BaseStationBarChart from "@/components/bss/BaseStationBarChart.vue";
import {ChartItem} from "chart.js";
import _ from "lodash";



@Component({
  components:{
    KeyValue,
    Loading,
    VueError,
    Spinner
  }
})
export default class BaseStationUniqueDevicesChart extends BaseStationBarChart {
  private bssService:BssService = curBssService;

  get id(): string {
    return `base-station-cnt-devices-chart-canvas-${this.lrrId}-${this.timeType}`;
  }

  mounted() {
    const ctx = document.getElementById(this.id);
    this.createChart(ctx as ChartItem);
  }

  protected async fetchChartDataImpl(lrrId: string,
                                     start: number,
                                     finish: number,
                                     interval: number,
                                     timeType: string): Promise<any> {
    const dataFromDl = await this.getBaseStationUniqueDevices(lrrId,
        start,
        finish,
        interval,
        timeType);
    const ret = {
      labels: _.map(dataFromDl, item => item.ts),
      datasets: [{
        categoryPercentage: 1.0,
        barPercentage: .9,
        label: 'number of unique devices',
        backgroundColor: '#17a2b8',
        data: _.map(dataFromDl, item => item.uniqueDevices)
      }],
    };
    return ret;
  }

  protected calcIntervalFromStartFinish(startSec: number, finishSec: number): number {
    const rangeAsNumberOfHours = Math.floor((finishSec - startSec) / 3600 );
    let intervalSec = 60;
    if ( rangeAsNumberOfHours > 5 * 24 ) {
      intervalSec = 24 * 3600;
    } else if ( rangeAsNumberOfHours >= 12 ) {
      intervalSec = 3600;
    }
    return intervalSec;
  }

  async getBaseStationUniqueDevices(lrrId:string,
                                    start: number,
                                    finish: number,
                                    interval: number,
                                    timeType: string):Promise<UniqueDevicesTimeSeriesPoint[]> {
    const reply = await this.bssService.getBaseStationUniqueDevicesTimeSeries({
      lrrId,
      start,
      finish,
      interval,
      timeType,
    });
    return Promise.resolve(reply.timeSeries as UniqueDevicesTimeSeriesPoint[]);
  }
}
